(function ($) {
  // Toggle second-level dropdowns in collapsed navbar
  $(".navbar .dropdown-submenu .dropdown-toggle").on("click", function (e) {
    e.preventDefault(); // Don't navigate
    e.stopPropagation(); // Don't bubble to parent dropdown

    var $toggle = $(this);
    var $submenu = $toggle.next(".dropdown-menu");
    var $parentMenu = $toggle.closest(".dropdown-menu");

    // Close any open sibling submenus
    $parentMenu.find(".dropdown-menu.show").not($submenu).removeClass("show");

    // Toggle this submenu
    $submenu.toggleClass("show");

    // Keep the top-level dropdown open
    $toggle.closest(".dropdown").addClass("show");
    $parentMenu.addClass("show");

    // Accessibility: reflect expanded state
    $toggle.attr("aria-expanded", $submenu.hasClass("show"));
  });

  // Prevent clicks inside dropdown from collapsing the navbar
  $(".navbar .dropdown-menu").on("click", function (e) {
    e.stopPropagation();
  });

  // When the parent dropdown hides, also hide nested submenus
  $(".navbar .dropdown").on("hidden.bs.dropdown", function () {
    $(this).find(".dropdown-menu.show").removeClass("show");
    $(this)
      .find('.dropdown-submenu .dropdown-toggle[aria-expanded="true"]')
      .attr("aria-expanded", "false");
  });
})(jQuery);
